import {baseApi} from "../../../app/api/baseApi";
import {CmQueryResult} from "../../../app/types";
import {AccessUser} from "../types";

export const accessManagementApiSlice = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAccessUsers: builder.query<AccessUser[], void>({
            query: () => {
                return {
                    reducerPath: 'accessUsers',
                    url: `/api/v1/users?page=1&items=200`,
                    method: 'GET',
                }
            },
            transformResponse: (response: CmQueryResult<AccessUser[]>) => {
                return response.data
            },
            keepUnusedDataFor: 120
        }),
    })
})

export const {
    useGetAccessUsersQuery,
} = accessManagementApiSlice
